module.exports = __webpack_public_path__ + "static/beautifly-1a732f44098730dde35888046af7d1da.jpg";